export default "__VITE_ASSET__WXAZ4Kds__"